import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './actions';
import * as taskTypesActions from '../../actions/taskTypesActions';
import * as taskActions from '../../actions/taskActions';
import selectAllProps from './selectors';
import Validator from 'validatorjs';
import toastr from 'toastr';
import MyLoader from '../../components/MyLoader'
import {change} from 'redux-form';

import NewTaskForm from './NewTaskForm';

class NewTaskContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            errors: {}
        }
    }

    componentWillMount() {
        this.props.actions.getMyProjects();
        this.props.taskTypesActions.getAll();
        //console.log('NewTaskContainer > componentWillMount', this.props);
    }

    validate(data) {
        let errors = {};
        const rules = {
            project: 'required',
            taskType: 'required',
            hours: 'required|numeric',
            minutes: 'required|numeric'
        };
        const messages = {
            required: 'Vous devez remplir ce champ.'
        };
        if(!data.hours && data.minutes){
            data = Object.assign({},data,{hours:'00'});
            this.props.changeFieldValue('hours','00');
        }
        if(!data.minutes && data.hours){
            data = Object.assign({},data,{minutes:'00'});
            this.props.changeFieldValue('minutes','00');
        }
        let validator = new Validator(data, rules, messages);
        if (validator.fails()) {
            errors = validator.errors.all();
        }
        return errors;
    }

    storeTask(data) {
        if(!data.hours && data.minutes){
            data = Object.assign({},data,{hours:'00'});
            this.props.changeFieldValue('hours','00');
        }
        if(!data.minutes && data.hours){
            data = Object.assign({},data,{minutes:'00'});
            this.props.changeFieldValue('minutes','00');
        }
        console.log(data);
        this.setState({errors:{}});
        if (this.props.task && this.props.task.id) {
            this.props.taskActions.update(data).then((response) => {
                this.context.router.goBack();
                toastr.success('Tache modifiée avec succès','Modification');
            },(errors) => {
                this.setState({errors});
                toastr.error('Tache invalide','Modification');
            });
        } else {
            this.props.taskActions.store(data).then((response) => {
                this.context.router.goBack();
                toastr.success('Tache ajoutée avec succès','Modification');
            }, (errors) => {
                this.setState({errors});
                toastr.error('Tache invalide','Création');
            });
        }
    }

    render() {
        const validate = this.validate.bind(this);
        const submit = this.storeTask.bind(this);
        //if (this.props.timeSheets.length == 0 || this.state.selectedTimeSheet == null) return (<MyLoader/>);
        return (
            <NewTaskForm {...this.props} {...this.state} validate={validate} onSubmit={submit} date={this.props.params.timeSheet}/>
        );
    }
}

NewTaskContainer.contextTypes = {
    router: PropTypes.object
};

NewTaskContainer.propTypes = {
    actions: PropTypes.object,
    taskTypesActions: PropTypes.object,
    taskActions: PropTypes.object,
    params: PropTypes.object,
    task: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        taskTypesActions: bindActionCreators(taskTypesActions, dispatch),
        taskActions: bindActionCreators(taskActions, dispatch),
        changeFieldValue: function(field, value) {
            dispatch(change('newProjectForm', field, value));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewTaskContainer);


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/NewTaskContainer.js
 **/